export const normalizePostalCode = (value?: string | null): string => {
  if (!value) {
    return ''
  }

  return value.trim().replace(/\s+/g, ' ')
}

export const isValidPostalCode = (value?: string | null): boolean => {
  const normalized = normalizePostalCode(value)
  if (!normalized) {
    return true
  }

  if (!/^[A-Za-z0-9 -]+$/.test(normalized)) {
    return false
  }

  const compact = normalized.replace(/[\s-]/g, '')
  return compact.length >= 3 && compact.length <= 12 && /\d/.test(compact)
}
